import { render, staticRenderFns } from "./GlassesVisualizer.vue?vue&type=template&id=2d940242&scoped=true&"
import script from "./GlassesVisualizer.vue?vue&type=script&lang=ts&"
export * from "./GlassesVisualizer.vue?vue&type=script&lang=ts&"
import style0 from "./GlassesVisualizer.vue?vue&type=style&index=0&id=2d940242&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d940242",
  null
  
)

export default component.exports